// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* @import '~pickerjs/index.css' */\n/* @import '~pickerjs/dist/picker.min.css' */", "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,4CAA4C","sourcesContent":["/* @import '~pickerjs/index.css' */\n/* @import '~pickerjs/dist/picker.min.css' */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
